import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';
import Tooltip from '../../../../../components/ToolTip';
import { formatCurrencyAmount, formatNumberValue, unformatNumberValue } from '../../../../../utils/miscFunctions';
// Skeleton loader component
export const SkeletonLoader = () => (
   <div className={`overflow-hidden rounded-2xl border border-gray-200 dark:!text-darkBg-mainText dark:bg-darkBg dark:border dark:border-darkBg-border`}>
        <div className="p-5">
          <div className="flex items-center">
            <div className="w-0 flex-1">
              <div className='flex items-center gap-2'>
                <div className={`animate-pulse h-[50px] w-[60px] bg-gray-200 rounded-full`}></div>
                <div className='flex flex-col w-full'>
                  <div className="animate-pulse space-y-2">
                    <div className="h-6 bg-gray-200  rounded w-2/3"></div>
                    <div className="h-6 bg-gray-200  rounded w-1/3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
);
export enum ChangeType {
    positive = 'positive',
    negative = 'negative',
    neutral = 'neutral'
}
interface IStatsCard {
  title: string;
  value: string | number;
  change?: string | number;
  changeType?: ChangeType;
  icon: any;
  isClickable?: boolean;
  color?: 'blue' | 'green' | 'yellow' | 'red' | 'gray' | 'gold' | 'indigo';
  period?: string;
  onClick?: () => void;
  loading?: boolean;
  className?: string;
}

export const StatsCard: React.FC<IStatsCard> = ({ title, value, change, changeType = ChangeType.neutral, icon: Icon, color = 'gray', onClick, isClickable=true, period, loading, className }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 ',
    green: 'bg-green-50 text-green-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    red: 'bg-red-50 text-red-600',
    gray: 'bg-gray-50 text-gray-600',
    gold:  'bg-[#FFFBE6] text-[#CCAC00]',
    indigo: 'bg-indigo-50 text-indigo-600',
  };

  const changeClasses = {
    positive: 'text-green-600',
    negative: 'text-red-600',
    neutral: 'text-gray-500',
  };

  if(loading) {
    return (
      <SkeletonLoader />
    );
  }
 
  return (
    <div className={`overflow-hidden rounded-2xl ${isClickable && 'cursor-pointer'} border ${colorClasses[color]} ${className}`} onClick={onClick}>
      <div className="p-5">
        <div className="flex items-center">
          <div className="w-0 flex-1">
            <div className='flex items-center gap-2'>
              <div ><Icon className={`h-[20px] w-[20px] ${colorClasses[color]} dark:bg-transparent dark:text-white`} /></div>
              <div className='flex flex-col  '>
                 <div className={`text-sm font-medium  ${colorClasses[color]} dark:bg-transparent dark:text-white`}>{title} - {period}</div>
                  <div className="flex items-baseline">
                    {change && (
                      <div className={`ml-2 flex items-baseline text-lg font-semibold ${changeClasses[changeType]} dark:bg-transparent dark:text-white`}>
                        {changeType === 'positive' ? '+' : ''}{change}
                      </div>
                    )}
                  </div>
                  
                
                  <div>{formatNumberValue(value).toString().includes('k') ||
                    formatNumberValue(value).toString().includes('M')
                  
                  ? <Tooltip
                    placement="bottom"
                    bgColor={`bg-gray-600`}
                    textColor="text-white"
                    message={formatCurrencyAmount(value, undefined, true)}>
                    <div className={`md:text-lg lg:text-md w-fit font-bold ${colorClasses[color]} dark:bg-transparent dark:text-white`}>
                      {formatNumberValue(value)}
                    </div>
                  </Tooltip>
                  
                  : <div className={`md:text-lg lg:text-md font-bold ${colorClasses[color]} dark:bg-transparent dark:text-white`}>
                      {formatNumberValue(value)}
                    </div>
                  }</div>
              </div>
             
               
             
            </div>
             
          </div>
        </div>
      </div>
    </div>
  );
};